import { isValid } from 'iban';

function useIbanValidator(iban: string) {
  if (isValid(iban)) {
    return true;
  }
  return false;
}
export default useIbanValidator;
